import { MapPin, Monitor } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { cn } from "@/lib/utils";

type Mode = "digital" | "onsite";

const badgeClass =
  "rounded-full border border-primary/20 bg-primary text-primary-foreground shadow-[0_2px_8px_-2px_hsl(162_52%_8%/0.35)]";

export const ModeBadge = ({
  mode,
  size = "sm",
  className,
}: {
  mode: Mode;
  size?: "sm" | "md";
  className?: string;
}) => {
  const { t } = useLang();
  const Icon = mode === "digital" ? Monitor : MapPin;
  const label = mode === "digital" ? t.services.digital : t.services.onsite;

  return (
    <span
      className={cn(
        "inline-flex items-center justify-center gap-1.5 font-medium leading-none",
        size === "sm" ? "h-7 px-3 text-[11px]" : "h-8 px-3.5 text-xs",
        badgeClass,
        className,
      )}
    >
      <Icon className={size === "sm" ? "h-3 w-3" : "h-3.5 w-3.5"} aria-hidden />
      {label}
    </span>
  );
};

export const ModeBadges = ({
  modes,
  size = "sm",
  className,
}: {
  modes: readonly Mode[];
  size?: "sm" | "md";
  className?: string;
}) => (
  <div className={cn("flex flex-wrap justify-end gap-1.5", className)}>
    {modes.includes("digital") ? <ModeBadge mode="digital" size={size} /> : null}
    {modes.includes("onsite") ? <ModeBadge mode="onsite" size={size} /> : null}
  </div>
);
